/* global process */
import React from "react";
import ReactGA from "react-ga4";
import {createRoot} from "react-dom/client";
import App from "./app/App";
import * as Sentry from "@sentry/react";

// import "./assets/scss/index.scss";
// import "react-app-polyfill/ie11";
// import "react-app-polyfill/stable";

Sentry.init({
  dsn: "https://3162d99f868370d835fa81db3168c674@o4509037329252352.ingest.de.sentry.io/4509037331021904",
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: 1.0,
  environment: process.env.REACT_APP_NODE_ENV,
});

const {REACT_APP_GOOGLE_ANALYTICS_UA} = process.env;

ReactGA.initialize(REACT_APP_GOOGLE_ANALYTICS_UA);
const container = document.getElementById("root");
const root = createRoot(container);
root.render(<App/>);